export function generateDashboardInsight(topScorers) {
  if (!topScorers || topScorers.length < 2) return null;

  const nonLeaders = topScorers.slice(1, 20);
  const risingPlayer = nonLeaders.reduce((best, p) => {
    const gpg = p.goals_per_game || (p.total_appearances > 0 ? p.total_goals / p.total_appearances : 0);
    const bestGpg = best.goals_per_game || (best.total_appearances > 0 ? best.total_goals / best.total_appearances : 0);
    return gpg > bestGpg ? p : best;
  }, nonLeaders[0]);

  if (!risingPlayer) return null;

  const gpg = risingPlayer.goals_per_game || (risingPlayer.total_goals / risingPlayer.total_appearances);

  return {
    playerName: risingPlayer.player_name,
    club: risingPlayer.club_name,
    text: `Watch ${risingPlayer.player_name} at ${risingPlayer.club_name}. GPG of ${gpg.toFixed(2)} with ${risingPlayer.total_goals} goals in ${risingPlayer.total_appearances} appearances in the ${risingPlayer.league_name}.`,
    linkText: 'Full Scouting Report',
  };
}

export function generatePlayerRecommendation(player, allPlayers) {
  if (!player || !allPlayers || allPlayers.length === 0) return null;

  const rank = allPlayers.findIndex(p => p.player_name === player.player_name) + 1;
  const gpg = player.goals_per_game || (player.total_appearances > 0 ? player.total_goals / player.total_appearances : 0);
  const total = allPlayers.length;

  const isTopInLeague = allPlayers
    .filter(p => p.league_name === player.league_name)
    .sort((a, b) => (b.total_goals || 0) - (a.total_goals || 0))[0]?.player_name === player.player_name;

  let text = '';
  if (isTopInLeague) {
    text += `Top scorer in ${player.league_name}. `;
  }
  text += `${player.total_goals} goals in ${player.total_appearances} appearances. `;
  text += `GPG of ${gpg.toFixed(2)} ranks #${rank} across all ${total} tracked players.`;

  return { text, rank, total, isTopInLeague };
}

export function generateLeagueInsight(leaguePlayers, leagueName) {
  if (!leaguePlayers || leaguePlayers.length === 0) return null;

  const totalGoals = leaguePlayers.reduce((sum, p) => sum + (p.total_goals || 0), 0);
  const topPlayer = leaguePlayers[0];
  if (!topPlayer || totalGoals === 0) return null;

  const pct = ((topPlayer.total_goals / totalGoals) * 100).toFixed(0);

  return {
    text: `${topPlayer.player_name} accounts for ${pct}% of ${leagueName}'s tracked goals.`,
    playerName: topPlayer.player_name,
    pct: parseInt(pct),
  };
}
